import { Datagrid, List, Resource, TextField } from 'react-admin';
import gql from 'graphql-tag';

export const name = 'BusinessMetricWorkoutSummary';

export const fragments = {
  type: 'document',
  doc: gql`
    fragment FragBusinessMetricWorkoutSummaries on businessMetricWorkoutSummaries {
      id
      date
      minutes
      workouts
      __typename
    }
  `
};

const list = () => (
  <List>
    <Datagrid rowClick="show">
      <TextField source="id" />
      <TextField source="date" />
      <TextField source="minutes" />
      <TextField source="workouts" />
    </Datagrid>
  </List>
);

export default function AdminResource(props) {
  return <Resource list={list} name={name} {...props} />;
}
